import { Subject } from 'rxjs';
export class NotifierService {
    constructor() {
        this.messageSubject = new Subject();
        this.messageObservable = this.messageSubject.asObservable();
    }
    postMessage(message) {
        this.messageSubject.next(message);
    }
}
